import { Dashboard, DigitalCourse, Events, Groups, TMATT } from 'types/access'

type AccessList = Dashboard | DigitalCourse | TMATT | Events
type AccessMap = {
  [key in Groups]: {
    id: number
    access: [
      AccessList,
      {
        mask: number
        block: number
      }
    ][]
  }
}

const ACCESS_MAPPING: [Groups, AccessList[]][] = [
  [Groups.APP, []],
  [
    Groups.DIGITAL_COURSE,
    [
      DigitalCourse.VIEW,
      DigitalCourse.ENROLL,
      DigitalCourse.ADJUST_POSITION,
      DigitalCourse.REINSTATE,
    ],
  ],
  [
    Groups.EVENTS,
    [
      Events.LIST_ALL_AVAILABILITIES,
      Events.LIST_AVAILABILITIES,
      Events.VIEW_ALL_AVAILABILITIES,
      Events.VIEW_AVAILABILITIES,
      Events.CREATE_ALL_INTRO_AVAILABILITIES,
      Events.CREATE_ALL_IN_PERSON_COURSE_AVAILABILITIES,
      Events.CREATE_ALL_DC_COURSE_AVAILABILITIES,
      Events.CREATE_INTRO_AVAILABILITIES,
      Events.CREATE_IN_PERSON_COURSE_AVAILABILITIES,
      Events.CREATE_DC_COURSE_AVAILABILITIES,
      Events.CREATE_TEST_DC_COURSE_AVAILABILITIES,
      Events.UPDATE_ALL_AVAILABILITIES,
      Events.UPDATE_AVAILABILITIES,
      Events.DELETE_AVAILABILITIES,
      Events.DELETE_ALL_AVAILABILITIES,

      Events.LIST_ALL_EXCEPTIONS,
      Events.LIST_EXCEPTIONS,
      Events.VIEW_ALL_EXCEPTIONS,
      Events.VIEW_EXCEPTIONS,
      Events.CREATE_ALL_EXCEPTIONS,
      Events.CREATE_EXCEPTIONS,
      Events.UPDATE_ALL_EXCEPTIONS,
      Events.UPDATE_EXCEPTIONS,
      Events.DELETE_ALL_EXCEPTIONS,
      Events.DELETE_EXCEPTIONS,

      Events.LIST_ALL_APPOINTMENTS,
      Events.LIST_APPOINTMENTS,
      Events.VIEW_ALL_APPOINTMENTS,
      Events.VIEW_APPOINTMENTS,
      Events.CREATE_ALL_APPOINTMENTS,
      Events.CREATE_APPOINTMENTS,
      Events.UPDATE_ALL_APPOINTMENTS,
      Events.UPDATE_APPOINTMENTS,
      Events.DELETE_ALL_APPOINTMENTS,
      Events.DELETE_APPOINTMENTS,
    ],
  ],
  [Groups.LIBRARY, []],
  [
    Groups.DASHBOARD,
    [
      Dashboard.LIST_ALL_USERS,
      Dashboard.LIST_USERS,
      Dashboard.VIEW_ALL_USERS,
      Dashboard.VIEW_USERS,
      Dashboard.CREATE_USERS,
      Dashboard.CREATE_TEACHERS,
      Dashboard.CREATE_TEST_USERS,
      Dashboard.UPDATE_ALL_USERS,
      Dashboard.UPDATE_USERS,
      Dashboard.DELETE_USERS,
      Dashboard.DEACTIVATE_USERS,
      Dashboard.CLEAR_DEVICES,
      Dashboard.SEND_DOWNLOAD_INSTRUCTION,
      Dashboard.VIEW_HELP_CENTER,
      Dashboard.NO_DATE_OF_INSTRUCTION_RESTRICTION,
    ],
  ],
  [Groups.TMATT, [TMATT.ENROLL, TMATT.PUBLISH_SUBTITLES]],
]

let accessMap: AccessMap

const getMap = () => {
  if (!accessMap) {
    accessMap = ACCESS_MAPPING.reduce((map, [group, access], id) => {
      map[group] = {
        id,
        access: access.map((key, index) => {
          const mask = 0x1 << (7 - (index % 8))
          const block = (index / 8) << 0

          return [
            key,
            {
              mask,
              block,
            },
          ]
        }),
      }

      return map
    }, {} as AccessMap)
  }

  return accessMap
}

const getBytes = (token: string): Uint8Array => {
  return Uint8Array.from(atob(token), (c) => c.charCodeAt(0))
}

export const hasAccess = (token: string, group: Groups, flag: AccessList) => {
  const map = getMap()

  const { id, access } = map[group]

  const buffer = getBytes(token)

  let pointer = 0

  while (pointer < buffer.length) {
    if (buffer[pointer] === id) {
      const { mask, block } = Object.fromEntries(access)[flag]

      const byte = buffer[pointer + 2 + block]

      return (byte & mask) === mask
    }

    const accessListSize = buffer[pointer + 1]

    pointer += accessListSize + 2
  }

  return false
}
